import { IFormPartnerMarketLeasing } from 'legacy/lut/classes/models/partner360/IFormPartnerMarketLeasing'
import { IPartnerMarketLeasing } from 'legacy/lut/features/partner360/marketInfo'

import { IJBPMarketLeasingCrudParams } from '../models'

interface IFullPartnerMarketLeasingData
  extends IPartnerMarketLeasing,
    IJBPMarketLeasingCrudParams {}

export const mapMarketLeasingTo1018 = (
  data: IFullPartnerMarketLeasingData
): IFormPartnerMarketLeasing => {
  const mappedData: IFormPartnerMarketLeasing = {
    EntryId: data.entryId,

    PartnerId: data.partnerId,
    ProgramType: data.programType,
    FYear: data.fYear,

    LeasingCompany1: data.company1,
    LeasingCompany2: data.company2,
    LeasingCompany3: data.company3,

    LeasingOffer: data.isLeasingOffer === null ? null : data.isLeasingOffer ? 1 : 0,
    DevicesFunded: data.devicesFunded,
  }

  for (const key in mappedData) {
    if (mappedData[key] === undefined || mappedData[key] === null) {
      delete mappedData[key]
    }
  }

  return mappedData
}
